import { render, staticRenderFns } from "./WidgetPreview.vue?vue&type=template&id=2f4f61d3&scoped=true"
import script from "./WidgetPreview.vue?vue&type=script&lang=js"
export * from "./WidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./WidgetPreview.vue?vue&type=style&index=0&id=2f4f61d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4f61d3",
  null
  
)

export default component.exports